export default __webpack_public_path__ + "static/media/404.df5241b6.png";